export const setupMutationTypes = {
  BENCHMARKS_LIST_LOADING: 'BENCHMARKS_LIST_LOADING',
  BENCHMARKS_LIST_ERROR: 'BENCHMARKS_LIST_ERROR',
  BENCHMARKS_LIST_DATA: 'BENCHMARKS_LIST_DATA',
  ADD_BENCHMARKS_PERIOD: 'ADD_BENCHMARKS_PERIOD',
  UPDATE_BENCHMARKS_LOADING: 'UPDATE_BENCHMARKS_LOADING',
  UPDATE_BENCHMARKS_ERROR: 'UPDATE_BENCHMARKS_ERROR',
};
